import { VideoProvider } from '../providers/videoProvider';
import { AsyncAction } from '../../base-classes/asyncAction';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_VIDEOS = new AsyncAction('GET_VIDEOS');

// get 1 or more videos by page number and page size
export function getVideos(...params) {
    let paramsObject = {
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        page: undefined,
        pageSize: undefined,
        verbose: undefined,
        stdParameters: undefined,
        refresh: undefined,
        disablePagination: undefined
    };

    paramsObject = mapParamsToObject(params, paramsObject);
    return {
        type: GET_VIDEOS.base,
        payload: getVideosApi(paramsObject),
        meta: {
            disablePagination: paramsObject.disablePagination
        }
    };
}

async function getVideosApi({ baseUrl, authId, secret, page, pageSize, verbose, stdParameters }) {
    const op = new VideoProvider(baseUrl, authId, secret);
    return await op.getVideos(page, pageSize, verbose, stdParameters);
}

// get one video by permalinkId
export const GET_VIDEO_BY_PLID = new AsyncAction('GET_VIDEO_BY_PLID');

export function getVideoByPlid(...params) {
    let paramsObject = {
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        permalinkId: undefined,
        verbose: undefined,
        stdParameters: undefined
    };

    paramsObject = mapParamsToObject(params, paramsObject);
    return {
        type: GET_VIDEO_BY_PLID.base,
        payload: getVideoByPlidApi(paramsObject)
    };
}

async function getVideoByPlidApi({ baseUrl, authId, secret, permalinkId, verbose, stdParameters }) {
    const op = new VideoProvider(baseUrl, authId, secret);
    return await op.getVideoByPlid(permalinkId, verbose, stdParameters);
}

export const CLEAR_VIDEOS = 'CLEAR_VIDEOS';

export function clearVideos() {
    return {
        type: CLEAR_VIDEOS
    };
}
